const InstagramIcon = (props) => (
  <svg
    width={52}
    height={48}
    viewBox="0 0 52 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={52} height={48} rx={6} fill="url(#paint0_linear_11_520)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.7 16.1H22.3C19.9804 16.1 18.1 17.9804 18.1 20.3V28.7C18.1 31.0196 19.9804 32.9 22.3 32.9H30.7C33.0196 32.9 34.9 31.0196 34.9 28.7V20.3C34.9 17.9804 33.0196 16.1 30.7 16.1ZM22.3 14C18.8206 14 16 16.8206 16 20.3V28.7C16 32.1794 18.8206 35 22.3 35H30.7C34.1794 35 37 32.1794 37 28.7V20.3C37 16.8206 34.1794 14 30.7 14H22.3ZM26.5 27.6501C28.2397 27.6501 29.65 26.2398 29.65 24.5001C29.65 22.7604 28.2397 21.3501 26.5 21.3501C24.7603 21.3501 23.35 22.7604 23.35 24.5001C23.35 26.2398 24.7603 27.6501 26.5 27.6501ZM26.5 29.7501C29.3995 29.7501 31.75 27.3996 31.75 24.5001C31.75 21.6006 29.3995 19.2501 26.5 19.2501C23.6005 19.2501 21.25 21.6006 21.25 24.5001C21.25 27.3996 23.6005 29.7501 26.5 29.7501ZM31.7496 20.72C32.5614 20.72 33.2196 20.0619 33.2196 19.25C33.2196 18.4381 32.5614 17.78 31.7496 17.78C30.9377 17.78 30.2796 18.4381 30.2796 19.25C30.2796 20.0619 30.9377 20.72 31.7496 20.72Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11_520"
        x1={1.93715e-7}
        y1={24}
        x2={52}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4264AA" />
        <stop offset={1} stopColor="#853F89" />
      </linearGradient>
    </defs>
  </svg>
);
export default InstagramIcon;
